/**
 * Search Modal Component
 *
 */
class SearchModal extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    this.openSearchModal = document.querySelectorAll('.open-searchform');
    this.searchFormContainer = this.querySelector('.searchform');

    this.searchFormContainer.addEventListener('keyup', (event) => {
      if(event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.openSearchModal.forEach(toggleBtn =>{
      toggleBtn.addEventListener('click', function(event){
        _this.onToggleBtnClick(event);
      });
      toggleBtn.setAttribute('role', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
    this.querySelector('.search-form__close-button').addEventListener('click', this.close.bind(this));
  }

  /**
   * To check if search modal is open or closed
   * 
   * @returns {boolean} true/false
   */
  isOpen() {
    return this.searchFormContainer.hasAttribute('open');
  }

  /**
   * Toggle Search Modal on search Icon click
   *
   * @param {event} Event instance
   */
  onToggleBtnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.searchFormContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /**
   * Open Search Modal and add attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  open(_event) {
    this.searchFormContainer.setAttribute('open', true);
    this.classList.add('open__modal');
    document.querySelector("body").classList.add("remove-scroll");
    document.querySelector("body").classList.add("search-open");
    document.querySelector(".overlay").classList.add("active");
    
    if(document.querySelector('.mobile-menu-wrapper').classList.contains('active_menu')){
      document.querySelector('.menu-close-icon .close-menu').dispatchEvent(new Event('click'));
    }
    if(document.querySelector('.cart-drawer').classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
  }

  /**              
   * Close Search Modal and remove attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  close(_focusToggle = true) {
    this.searchFormContainer.removeAttribute('open');
    this.classList.remove('open__modal');
    document.querySelector("body").classList.remove("remove-scroll");
    document.querySelector("body").classList.remove("search-open");
    document.querySelector(".overlay").classList.remove("active");
  }
}
customElements.define('search-form', SearchModal);